import apiClient from './api';

/**
 * Fetches all manager accounts for a given domain.
 * @param {number} domainId - The ID of the domain.
 * @returns {Promise<Array>} - An array of manager accounts.
 */
export const getAllManagerAccounts = async (domainId) => {
  try {
    const response = await apiClient.get(`api/Accounts/all/Managers/${domainId}`);
    return response.data;
  } catch (error) {
    // console.error("Error fetching manager accounts:", error.response?.data || error.message);
    throw new Error(error.response?.data || "Failed to fetch manager accounts.");
  }
};

/**
 * Fetches all validation types.
 * @returns {Promise<Array>} - An array of validation types.
 */
export const getValidationTypes = async () => {
  try {
    const response = await apiClient.get('api/ValidationTypes');
    return response.data;
  } catch (error) {
    console.error("Error fetching validation types:", error.response?.data || error.message);
    // throw new Error(error.response?.data || "Failed to fetch validation types.");
  }
};

/**
 * Creates a new validator.
 * @param {object} payload - The validator data (accountId, domainId, validationTypeId).
 * @returns {Promise<object>} - The created validator object.
 */
export const createValidator = async (payload) => {
  try {
    const response = await apiClient.post('api/Validators', payload);
    return response.data;
  } catch (error) {
    // console.error("Error creating validator:", error.response?.data || error.message);
    throw new Error(error.response?.data || "Failed to create validator.");
  }
};

/**
 * Fetches paginated Order validators for a given domain.
 * @param {number} domainId - The ID of the domain.
 * @param {number} pageNumber - The current page number.
 * @param {number} pageSize - The number of items per page.
 * @returns {Promise<object>} - Paged result of Order validators.
 */
export const getPaginatedOrderValidators = async (domainId, pageNumber = 1, pageSize = 10) => {
  try {
    const response = await apiClient.get(`api/Validators/All/Order/${domainId}`, {
      params: { pageNumber, pageSize }
    });
    // Assuming backend returns { items: [], totalItems: N, totalPages: M, pageNumber: P, pageSize: S }
    return response.data;
  } catch (error) {
    // console.error("Error fetching paginated Order validators:", error.response?.data || error.message);
    throw new Error(error.response?.data || "Erreur lors de la recuperation des validateurs d'ordre . veillez verifier votre connexion internet et reesayer");
  }
};

/**
 * Fetches paginated Account validators for a given domain.
 * @param {number} domainId - The ID of the domain.
 * @param {number} pageNumber - The current page number.
 * @param {number} pageSize - The number of items per page.
 * @returns {Promise<object>} - Paged result of Account validators.
 */
export const getPaginatedAccountValidators = async (domainId, pageNumber = 1, pageSize = 10) => {
  try {
    const response = await apiClient.get(`api/Validators/All/Account/${domainId}`, {
      params: { pageNumber, pageSize }
    });
    // Assuming backend returns { items: [], totalItems: N, totalPages: M, pageNumber: P, pageSize: S }
    return response.data;
  } catch (error) {
    // console.error("Error fetching paginated Account validators:", error.response?.data || error.message);
    throw new Error(error.response?.data || "Erreur lors de la recuperation des validateurs de compte . veillez verifier votre connexion internet et reesayer");
  }
};

export const deleteValidator = async (validatorId) => {
  try {
    const response = await apiClient.delete(`/api/Validators/${validatorId}`);
    return response.data;
  } catch (error) {
    // console.error(`Error deleting validator with ID ${validatorId}:`, error);
    throw error;
  }
};

// Nouvelle fonction pour la modification
export const updateValidator = async (validatorId, payload) => {
  try {
    const response = await apiClient.put(`/api/Validators/${validatorId}`, payload);
    return response.data;
  } catch (error) {
    console.error(`Erreur lors de la modification du validateur avec l'ID ${validatorId}:`, error);
    throw error;
  }
};

/**
 * Récupère les détails des entrées d'approbation pour une entité spécifique dans un domaine donné.
 * @param {number} entityId L'ID de l'entité (ordre ou compte).
 * @param {number} domainId L'ID du domaine.
 * @returns {Promise<Array>} Une promesse qui résout en une liste de détails d'approbation.
 */
export const getApprovalDetailsByEntityAndDomain = async (entityId, domainId) => {
  try {
    const response = await apiClient.get(`/api/Approvals/entity/${entityId}/domain/${domainId}`);
    return response.data;
  } catch (error) {
    // console.error(`Erreur lors de la récupération des détails d'approbation pour l'entité ${entityId} dans le domaine ${domainId}:`, error);
    throw new error;
  }
};